<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <form v-if="!this.$store.getters.isLoading" @submit.prevent="onsubmit()">
      <div class="row">
        <div class="flex md6 xs12">
          <va-input
            v-model="name"
            type="text"
            :label="$t('auth.name')"
            :error="!!nameErrors.length"
            :error-messages="nameErrors"
          />
        </div>

        <div class="flex md6 xs12">
          <va-input
            v-model="surname"
            type="text"
            :label="$t('auth.surname')"
            :error="!!surnameErrors.length"
            :error-messages="surnameErrors"
          />
        </div>

        <div class="flex md12 xs12">
          <va-input
            v-model="companyName"
            type="text"
            :label="$t('auth.company')"
            :error="!!companyErrors.length"
            :error-messages="companyErrors"
          />
        </div>

        <div class="flex md6 xs12">
          <va-select
            :label="$t('auth.country')"
            v-model="countryId"
            textBy="name"
            keyBy="countryId"
            searchable
            class="md-6"
            :options="countries"
            :error="!!countryErrors.length"
            :error-messages="countryErrors"
          />
        </div>

        <div class="flex md6 xs12">
          <va-select
            :label="$t('auth.market')"
            v-model="marketValue"
            textBy="name"
            keyBy="marketValue"
            class="md-6"
            :options="markets"
            :error="!!marketErrors.length"
            :error-messages="marketErrors"
          />
        </div>

        <div class="flex md12 xs12">
          <va-input
            v-model="mobile"
            type="text"
            :label="$t('auth.mobile')"
            :error="!!mobileErrors.length"
            :error-messages="mobileErrors"
          />
        </div>

        <div class="flex md12 xs12">
          <va-input
            v-model="email"
            type="email"
            :label="$t('auth.email')"
            :error="!!emailErrors.length"
            :error-messages="emailErrors"
          />
        </div>

        <div class="flex md6 xs12">
          <va-input
            v-model="password"
            type="password"
            :label="$t('auth.password')"
            :error="!!passwordErrors.length"
            :error-messages="passwordErrors"
          />
        </div>

        <div class="flex md6 xs12">
          <va-input
            v-model="confirmPassword"
            type="password"
            :label="$t('auth.confirmPassword')"
            :error="!!confirmPasswordErrors.length"
            :error-messages="confirmPasswordErrors"
          />
        </div>
      </div>

      <div class="auth-layout__options d-flex align--center justify--space-between">
        <va-checkbox
          v-model="agreedToTerms"
          class="mb-0"
          :error="!!agreedToTermsErrors.length"
          :errorMessages="agreedToTermsErrors"
        >
          <template slot="label">
            {{ $t('auth.agree') }}
            <a href="https://ipark.gr/terms-of-service/" target="_blank" class="link">{{ $t('auth.termsOfUse') }}</a>
            {{ $t('auth.and') }}
            <a href="https://ipark.gr/legal-info/" target="_blank" class="link">{{ $t('auth.servicesAgreement') }}</a>
          </template>
        </va-checkbox>
        <router-link class="ml-1 link" :to="{name: 'recover-password'}">
          {{$t('auth.recoverPassword')}}
        </router-link>
      </div>

      <div class="d-flex justify--center mt-3">
        <va-button type="submit" class="my-0" style="background-image: unset; background-color: rgb(108, 127, 238); box-shadow: rgb(10 13 117 / 25%) 0 1px 1px 0;">{{ $t('auth.signUp') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'signup',
  data () {
    return {
      name: '',
      surname: '',
      mobile: '',
      email: '',
      password: '',
      confirmPassword: '',
      countryId: '',
      marketValue: '',
      companyName: '',
      countries: [],
      markets: [
        {
          marketValue: 'Valet Operator',
          name: this.$t('auth.markets.valetOperator'),
        },
        {
          marketValue: 'Parking Lot',
          name: this.$t('auth.markets.parkingLot'),
        },
        {
          marketValue: 'Events Organizator',
          name: this.$t('auth.markets.eventsOrganizator'),
        },
        {
          marketValue: 'Hotel',
          name: this.$t('auth.markets.hotel'),
        },
        {
          marketValue: 'Hospital',
          name: this.$t('auth.markets.hospital'),
        },
        {
          marketValue: 'Restaurant',
          name: this.$t('auth.markets.restaurant'),
        },
        {
          marketValue: 'Other',
          name: this.$t('auth.markets.other'),
        },
      ],
      agreedToTerms: false,
      nameErrors: [],
      surnameErrors: [],
      mobileErrors: [],
      emailErrors: [],
      passwordErrors: [],
      confirmPasswordErrors: [],
      companyErrors: [],
      countryErrors: [],
      marketErrors: [],
      agreedToTermsErrors: [],
    }
  },
  methods: {
    onsubmit () {
      this.nameErrors = this.name ? [] : [this.$t('auth.nameError')]
      this.surnameErrors = this.surname ? [] : [this.$t('auth.surnameError')]
      this.emailErrors = this.email ? [] : [this.$t('auth.emailError')]
      this.passwordErrors = this.password ? [] : [this.$t('auth.passwordError')]
      this.confirmPasswordErrors = this.confirmPassword ? [] : [this.$t('auth.confirmPasswordError')]
      this.companyErrors = this.companyName ? [] : [this.$t('auth.companyError')]
      this.countryErrors = this.countryId ? [] : [this.$t('auth.countryError')]
      this.marketErrors = this.marketValue ? [] : [this.$t('auth.marketError')]
      this.agreedToTermsErrors = this.agreedToTerms ? [] : [this.$t('auth.agreedToTermsError')]

      if (this.password !== this.confirmPassword) {
        this.passwordErrors.push(this.$t('auth.passwordsMismatchError'))
        this.confirmPasswordErrors.push(this.$t('auth.passwordsMismatchError'))
      }

      if (this.mobile) {
        const phoneRegex = /^\+?[0-9]{6,14}$/
        if (!phoneRegex.test(this.mobile)) {
          this.mobileErrors.push(this.$t('auth.invalidPhoneError'))
        } else {
          this.mobileErrors = []
        }
      }

      if (!this.formReady) {
        return
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('register', {
        name: this.name,
        surname: this.surname,
        email: this.email,
        mobile: this.mobile,
        password: this.password,
        confirmPassword: this.confirmPassword,
        companyName: this.companyName,
        countryId: this.countryId.countryId,
        market: this.marketValue.marketValue,
      }).then(() => this.$router.push({ name: 'dashboard' })).catch(error => this.errorHandler(error.response))
    },
    async initSignup () {
      this.countries.splice(0, this.countries.length, ...this.$store.getters.countries)
      this.$store.commit('setLoading', false)
    },
  },
  computed: {
    formReady () {
      return !(this.nameErrors.length || this.surnameErrors.length || this.mobileErrors.length ||
        this.emailErrors.length || this.passwordErrors.length || this.confirmPasswordErrors.length ||
        this.agreedToTermsErrors.length || this.companyErrors.length || this.countryErrors.length ||
        this.marketErrors.length)
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('countries').then(() => this.initSignup()).catch(error => this.errorHandler(error.response))
  },
}
</script>

<style lang="scss">
  form .row .flex {
    padding: 0 5px;
  }

  @media screen and (max-width: 767px) {
    form .row .flex {
      padding: 0;
    }
  }
</style>
